import BreakdownReport from '../components/home/Assets/Report/BreakdownReport';
import WorkOrder from '../components/home/Assets/WorkOrder';



export enum AppRoutes {
    Home = "/home",
    Account = "/account",
    Login = "/signin",
    PublicRFQ = "/public/requestforquotation",
    PublicPO = "/public/purchaseorder",
    PublicBreakdown = "/public/reportbreakdown",
    SignUp = "/signup",
    MFEDashboard = "/mfe/dashboard/:dashboardId",
    PublicServiceApproval = "/external/schedule-approval/schedule_approval",
    PublicServiceAssetApproval = "/external/schedule-approval/schedule_asset_approval"
}

export enum HomeRoutes {
    Devices = AppRoutes.Home + "/devices",
    AddAndEditDevice = AppRoutes.Home + "/add-device",
    // Login = AppRoutes.Auth + "/signin",

    Projects = AppRoutes.Home + "/projects",
    Reports = AppRoutes.Home + "/project/reports",
    EnvironmentReports = AppRoutes.Home + "/environment-reports",
    EnvironmentConfiguration = AppRoutes.Home + "/environment-configuration",
    EnvironmentDevices = AppRoutes.Home + "/environment-monitoring/environment-devices",
    EnvironmentDashboard = AppRoutes.Home + "/environment-monitoring/environment-dashboard",
    ProjectDetails = AppRoutes.Home + "/project-details/:projectId",
    // SignUp = AppRoutes.Auth + "/signup",
    Maintanance = AppRoutes.Home + "/maintanance",
    Servicing = AppRoutes.Home + "/servicing",
    EditService = AppRoutes.Home + "/edit-service/:id",
    CreateService = AppRoutes.Home + "/create-service",
    ServicingDetails = AppRoutes.Home + "/service-details/:id",
    ServiceAssetDetails = AppRoutes.Home + "/service-detail/:serviceId/asset/:assetId",
    DeviceItem = AppRoutes.Home + "/device-data",
    Dashboard = AppRoutes.Home + "/dashboard",
    DashboardItem = AppRoutes.Home + "/dashboard/:id",
    Groups = AppRoutes.Home + "/user-group",
    DataDigest = AppRoutes.Home + "/data-digest",
    ItemGroup = AppRoutes.Home + "/item-group",
    Schedule = AppRoutes.Home + "/report-schedule",
    CreateSchedule = AppRoutes.Home + "/create-schedule",
    ReportFiles = AppRoutes.Home + "/report-files",
    UserProfile = AppRoutes.Home + "/user-profile",
    Users = AppRoutes.Home + "/users",
    CustomFields = AppRoutes.Home + "/custom-fields",
    Actions = AppRoutes.Home + "/Actions",
    Rules = AppRoutes.Home + "/Rules",
    Triggers = AppRoutes.Home + "/triggers",
    EventType = AppRoutes.Home + "/event-type",
    settings = AppRoutes.Home + "/settings",
    dataCollection = AppRoutes.Home + "/data",
    Report = AppRoutes.Home + "/reports",
    Events = AppRoutes.Home + "/events",
    EventActions = AppRoutes.Home + "/event-actions/:eventId",
    Viewbats = AppRoutes.Home + "/view-bats",
    AssetManagement = AppRoutes.Home + "/assets",
    AssetDocument = AppRoutes.Home + "/asset-document",
    AssetConfiguration = AppRoutes.Home + "/asset-configuration",
    ServiceReport = AppRoutes.Home + "/service-report",
    BreakdownReport = AppRoutes.Home + "/breakdown-report",
    Breakdown = AppRoutes.Home + "/breakdown",
    WorkOrder = AppRoutes.Home + "/workorder",
    BreakdownDetails = AppRoutes.Home + "/breakdownDetails/:breakdownId",
    WorkOrderDetails = AppRoutes.Home + "/workorderDetails/:orderId",
    PartReplacement = AppRoutes.Home + "/part-replacement",
    ViewAsset = AppRoutes.Home + "/view-assets",
    BatAdmin = AppRoutes.Home + "/admin-statistics",
    BatDashboard = AppRoutes.Home + "/bats",
    ViewRoomData = AppRoutes.Home + "/view-room/:roomId",
    SvgDashboard = AppRoutes.Home + "/view-svg-dashboard",
    ViewMap = AppRoutes.Home + "/view-map",
    Notification = AppRoutes.Home + "/view-notifications",
    ViewNotification = AppRoutes.Home + "/view-notification",
    BatsReport = AppRoutes.Home + "/audit-report",
    Parts = AppRoutes.Home + "/parts",
    PartDetails = AppRoutes.Home + "/partDetails",
    FindRequestPart = AppRoutes.Home + "/findRequestPart",
    RequestPartDetails = AppRoutes.Home + "/requestPartDetails",
    PartRequestHistory = AppRoutes.Home + "/partRequestHistory",
    PartRequestHDetails = AppRoutes.Home + "/partRequestHDetails",
    PartRequest = AppRoutes.Home + "/partRequest",
    PartRequestDetails = AppRoutes.Home + "/partRequestDetails",
    PartCollection = AppRoutes.Home + "/partCollection",
    PartCollectionDetails = AppRoutes.Home + "/partCollectionDetails",
    Vendors = AppRoutes.Home + "/vendors",
    VendorDetails = AppRoutes.Home + "/vendorDetails",
    RequestForQuotation = AppRoutes.Home + "/requestForQuotation",
    AddRFQ = AppRoutes.Home + "/addRFQ",
    RFQDetails = AppRoutes.Home + "/rfqDetails",
    Quotation = AppRoutes.Home + "/quotation",
    PurchaseOrder = AppRoutes.Home + "/purchaseOrder",
    PurchaseOrderDetails = AppRoutes.Home + "/purchaseOrderDetails",
    InventoryReport = AppRoutes.Home + "/inventory-report",
    InventoryConfiguration = AppRoutes.Home + "/inventory-configuration",
}

export enum TriggerRoutes {
    EditTrigger = HomeRoutes.Triggers + "/:triggerId",
    CreateTrigger = HomeRoutes.Triggers + "/create"
}

export enum GroupRoutes {
    ViewGroupdetails = HomeRoutes.Groups + "/:groupId",
    UserDetails = HomeRoutes.Users + "/:userId"
}

export enum ViewDeviceRoutes {
    ViewDevice = HomeRoutes.Devices + "/:deviceId",
}

export enum ViewEventActionRoutes {
    ViewEventActions = HomeRoutes.EventActions,
}

export enum ViewDeviceItemRoutes {
    ViewDeviceItem = HomeRoutes.DeviceItem + "/:deviceId",
}

export enum ViewCollectionRoutes {
    ViewCollection = HomeRoutes.dataCollection + "/:collectionId",
}

export enum ViewBatsRoutes {
    Viewbats = HomeRoutes.Viewbats,
    BatDashboard = HomeRoutes.BatDashboard,
    BatsReport = HomeRoutes.BatsReport,
    ViewRoomData = HomeRoutes.ViewRoomData,
    Report = HomeRoutes.Report,
    BatAdmin = HomeRoutes.BatAdmin,
    SvgDashboard = HomeRoutes.SvgDashboard,
    Notification = HomeRoutes.Notification,
    ViewNotification = HomeRoutes.ViewNotification + "/:notificationId"
}

export enum AssetsRoutes {
    AssetDocument = HomeRoutes.AssetDocument,
    AssetManagement = HomeRoutes.AssetManagement,
    AssetConfiguration = HomeRoutes.AssetConfiguration,
    ServiceReport = HomeRoutes.ServiceReport,
    BreakdownReport = HomeRoutes.BreakdownReport,
    Breakdown = HomeRoutes.Breakdown,
    WorkOrder = HomeRoutes.WorkOrder,
    BreakdownDetails = HomeRoutes.BreakdownDetails,
    WorkOrderDetails = HomeRoutes.WorkOrderDetails,
    PartReplacement = HomeRoutes.PartReplacement,
    ServicingDetails = HomeRoutes.ServicingDetails,
    ServiceAssetDetails = HomeRoutes.ServiceAssetDetails,
    Servicing = HomeRoutes.Servicing,
    Maintanance = HomeRoutes.Maintanance,
    EditService = HomeRoutes.EditService,
    CreateService = HomeRoutes.CreateService,
    ViewAsset = HomeRoutes.ViewAsset + "/:assetId",
    Parts = HomeRoutes.Parts,
    PartDetails = HomeRoutes.PartDetails + "/:partId",
    FindRequestPart = HomeRoutes.FindRequestPart,
    RequestPartDetails = HomeRoutes.RequestPartDetails + "/:partId",
    PartRequestHistory = HomeRoutes.PartRequestHistory,
    PartRequestHDetails = HomeRoutes.PartRequestHDetails,
    PartRequest = HomeRoutes.PartRequest,
    PartRequestDetails = HomeRoutes.PartRequestDetails,
    PartCollection = HomeRoutes.PartCollection,
    PartCollectionDetails = HomeRoutes.PartCollectionDetails,
    Vendors = HomeRoutes.Vendors,
    VendorDetails = HomeRoutes.VendorDetails + "/:vendorId",
    RequestForQuotation = HomeRoutes.RequestForQuotation,
    AddRFQ = HomeRoutes.AddRFQ,
    RFQDetails = HomeRoutes.RFQDetails,
    Quotation = HomeRoutes.Quotation,
    PurchaseOrder = HomeRoutes.PurchaseOrder,
    PurchaseOrderDetails = HomeRoutes.PurchaseOrderDetails,
    InventoryReport = HomeRoutes.InventoryReport,
    InventoryConfiguration = HomeRoutes.InventoryConfiguration,
}